import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './physics.component.html',
	styleUrls: ['./physics.component.css']
})

export class PhysicsComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/physics.component.ts